import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import ShiftAdminActions from '../actions/shift-admin.actions';

export function* getShiftPrevPeriodOverviewRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.getShiftPrevPeriodOverview(shiftId);
  if (response && response.ok) {
    yield put(ShiftAdminActions.getShiftPrevPeriodOverviewSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift prev period data', response);
    yield put(ShiftAdminActions.getShiftPrevPeriodOverviewFailure());
  }
}

export function* getShiftCommissionsRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.getShiftCommissions(shiftId);
  if (response && response.ok) {
    yield put(ShiftAdminActions.getShiftCommissionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift commissions', response);
    yield put(ShiftAdminActions.getShiftCommissionsFailure());
  }
}

// export function* getShiftAlertsFeedRequest(api, action) {
//   const response = yield api.getShiftAlertsFeed(action.id);
//   if (response && response.ok) {
//     yield put(ShiftAdminActions.getShiftAlertsFeedSuccess(response.data));
//   } else {
//     InsighttNotification('error', 'Unable to get shift alerts feed', response);
//     yield put(ShiftAdminActions.getShiftAlertsFeedFailure());
//   }
// }

// export function* getShiftAlertsPaginationFeedRequest(api, action) {
//   const { pageNumber, pageLimit, id } = action.payload;
//   const response = yield api.getShiftAlertsPaginationFeed({
//     pageNumber,
//     pageLimit,
//     id,
//   });
//   if (response && response.ok) {
//     yield put(ShiftAdminActions.getShiftAlertsPaginationFeedSuccess(response.data));
//   } else {
//     InsighttNotification('error', 'Unable to get shift alerts pagination feed', response);
//     yield put(ShiftAdminActions.getShiftAlertsPaginationFeedFailure());
//   }
// }

export function* saveAllInfractionsRequest(api) {
  const response = yield api.saveAllInfractions();
  if (response && response.ok) {
    yield put(ShiftAdminActions.saveAllInfractionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to save all infractions', response);
    yield put(ShiftAdminActions.saveAllInfractionsFailure());
  }
}

export function* saveUserInfractionAsRecordRequest(api, action) {
  const { feedId } = action;
  const response = yield api.saveUserInfractionAsRecord(feedId);
  if (response && response.ok) {
    InsighttNotification('success', 'Infraction were saved as record successfully', response);
    yield put(ShiftAdminActions.saveUserInfractionAsRecordSuccess(feedId));
  } else {
    InsighttNotification('error', 'Unable to save user infraction', response);
    yield put(ShiftAdminActions.saveUserInfractionAsRecordFailure());
  }
}

export function* deleteUserInfractionRequest(api, action) {
  const { feedId } = action;
  const response = yield api.deleteUserInfraction(feedId);
  if (response && response.ok) {
    InsighttNotification('success', 'Infraction were deleted successfully', response);
    yield put(ShiftAdminActions.deleteUserInfractionSuccess(feedId));
  } else {
    InsighttNotification('error', 'Unable to delete user infraction', response);
    yield put(ShiftAdminActions.deleteUserInfractionFailure());
  }
}

// export function* getShiftChecklistFeedRequest(api, action) {
//   const { page = 1, limit = 10, id = 0 } = action;
//   const response = yield api.getShiftChecklistFeed(page, limit, id);
//   if (response && response.ok) {
//     yield put(ShiftAdminActions.getShiftChecklistFeedSuccess(response.data));
//   } else {
//     InsighttNotification('error', 'Unable to get shift checklist feed', response);
//     yield put(ShiftAdminActions.getShiftChecklistFeedFailure());
//   }
// }

export function* markFailedChecklistAsCompletedRequest(api, action) {
  const { feedId } = action;
  const response = yield api.markFailedChecklistAsCompleted(feedId);
  if (response && response.ok) {
    InsighttNotification('success', 'Failed Checklist were completed successfully', response);
    yield put(ShiftAdminActions.markFailedChecklistAsCompletedSuccess(feedId));
  } else {
    InsighttNotification('error', 'Unable to complete failed checklist', response);
    yield put(ShiftAdminActions.markFailedChecklistAsCompletedFailure());
  }
}

export function* getShiftHotListFeedRequest(api, action) {
  const response = yield api.getShiftHotListFeed(action.branchId);
  if (response && response.ok) {
    yield put(ShiftAdminActions.getShiftHotListFeedSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift checklist feed', response);
    yield put(ShiftAdminActions.getShiftHotListFeedFailure());
  }
}

export function* updateHotListVehicleCommentRequest(api, action) {
  const { feedId, commentId, payload } = action;
  const response = yield api.updateHotListVehicleComment(feedId, commentId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Comment was updated successfully', response);
    yield put(ShiftAdminActions.updateHotListVehicleCommentSuccess(feedId, response.data));
  } else {
    InsighttNotification('error', 'Unable to update a comment', response);
    yield put(ShiftAdminActions.updateHotListVehicleCommentFailure(feedId, commentId));
  }
}

export function* deleteHotListVehicleCommentRequest(api, action) {
  const { feedId, commentId } = action;
  const response = yield api.deleteHotListVehicleComment(feedId, commentId);
  if (response && response.ok) {
    InsighttNotification('success', 'Comment was deleted successfully', response);
    yield put(ShiftAdminActions.deleteHotListVehicleCommentSuccess(feedId, commentId));
  } else {
    InsighttNotification('error', 'Unable to delete a comment', response);
    yield put(ShiftAdminActions.deleteHotListVehicleCommentFailure(feedId, commentId));
  }
}

export function* archiveManualHotListRequest(api, action) {
  const { feedId } = action;
  const response = yield api.archiveManualHotList(feedId);
  if (response && response.ok) {
    InsighttNotification('success', 'Manual Hot List were archived successfully', response);
    yield put(ShiftAdminActions.archiveManualHotListSuccess(feedId));
  } else {
    InsighttNotification('error', 'Unable to archive manual hot list', response);
    yield put(ShiftAdminActions.archiveManualHotListFailure());
  }
}
